export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/LensStockWorker.fb74dc27.worker.js");
}
